import React from 'react'

const Dashfilter = ({setDashboardfilter,dashboardfilter}) => {
    const handleCloseDashf=()=>{
        setDashboardfilter(false)
    }
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    {/* Popup Box */}
    <div className="relative flex flex-col gap-4 md:w-[30%] w-[80%] bg-white rounded-lg shadow-lg text-left">
      <div>
        <div className="w-full flex items-center justify-between mt-2 p-2 px-4">
          {/* Close Button */}
          <span className="ml-2 font-inter text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
           Filter
          </span>
          <button
            className="text-gray-500 hover:text-gray-700 text-[30px]"
            onClick={handleCloseDashf}
          >
            &times;
          </button>
        </div>
        <div className="h-px bg-[#D0D5DD]"></div>
      </div>

      {/* Provider Buttons */}
      <div className="flex flex-wrap gap-4 p-4">
    Dashfilter
      </div>

      {/* Update Button */}
      <div className="w-full flex justify-center mt-2 gap-4 py-2 border-t bg-[#F9FAFB] rounded">
      <div
          className="rounded cursor-pointer py-1 px-2 w-[25%] text-center font-inter transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] bg-[black] text-[#FFFFFF]"
        >
          Apply
        </div>
        <div
          className="rounded cursor-pointer py-1 px-2 w-[25%] text-center font-inter transition duration-300 ease-in-out text-gray-600 shadow-[0px_4px_4px_#00000040] border-2 border-gray-200"
        >
          Cancel
        </div>
      </div>
    </div>

  </div>
  )
}

export default Dashfilter
